import Base from './base'

type UpdateAccountParams = {
  archived?: boolean
  /** Replaces all tags on the account. */
  tags?: string[]
}

export default class PublicCompany extends Base {
  async updateAccount(accountId: number, data: UpdateAccountParams) {
    return await this.api.put(`accounts/${accountId}`, data)
  }
}
